import React from 'react'
// import TextField from '@material-ui/core/TextField'
// import OtherCardIcon from 'assets/svg-icons/OtherCardIcon'
// import MCIcon from 'assets/svg-icons/MCIcon'
// import VisaIcon from 'assets/svg-icons/VisaIcon'
// import AmexIcon from 'assets/svg-icons/AmexIcon'
// import { cardLocales } from 'utils/cardErrorLocales'

import WidgetPaymentError from '../WidgetPaymentError'
import WidgetPaymentInput from '../WidgetPaymentInput'
import { cardIcon } from '../../../../../../components/Icons';
import { useTranslation } from 'react-i18next';

import './widgetNewCardStyles.css'
// import Input from 'react-select/src/components/input'

const WidgetNewCard = ({
  shouldSave,
  setShouldSave,
  initPaymentController,
  paymentError,
  errors,
  setFullname,
  fullName,
  cardType,
}) => {
  React.useEffect(() => {
    initPaymentController()
  }, [initPaymentController])
  const { t } = useTranslation();
  const isOther = React.useMemo(() => {
    if (
      cardType === 'MASTERCARD' ||
      cardType === 'VISA' ||
      cardType === 'JCB' ||
      cardType === 'AMEX'
    ) return false
    if (!cardType) return false
    return true
  }, [cardType])

  const emptyNameInput = fullName.length === 0;
  const typingDirection = React.useMemo(() => {
    return emptyNameInput ? '' : 'auto';
    },[emptyNameInput]);

  return (
    <div className='widget-flow__wrapper'>
      <div className='widget-flow-about-inner'>
      
      
        <div className='widget-payment-fields-column'>
       
          <input
            id='payment-cardholder'
            placeholder={t(`Full name`)}
            variant='outlined'
            dir={typingDirection}
            value={fullName}
            onChange={(e) => setFullname(e.target.value)}
            className={'widget-payment-cardholder'}
          />
          <label>{t(`Name on card`)}</label>
        </div>
        <div className='widget-payment-fields-row'>
        <WidgetPaymentInput
            bluesnapName='ccn'
            label={t(`Card Number *`)}
              error={errors.ccn}
              Icon={cardIcon}
            //icon={<CreditCardIcon />}
          />
            <WidgetPaymentInput
              bluesnapName='exp'
              label={t(`Exp.Date *`)}
              error={errors.exp}

            //icon={<CalendarIcon />}
            />
          <WidgetPaymentInput
            cardType={cardType}
            bluesnapName='cvv'
            label={t(`Security code *`)}
            error={errors.cvv}

              // error={errors}

          // icon={<CCVIcon />}
          />
        </div>
        <div className='widget-payment-save-checkbox-container'>
          {/* <input
            type='button'
            checked={shouldSave}
            onChange={() => setShouldSave(state => !state)}
            className='widget-payment-save-checkbox'
            id='widget-payment-save-checkbox'
            value=' Save this card'
          /> */}
   
          {/* <la bel htmlFor='widget-payment-save-checkbox' className='widget-payment-save-label'>
            Save this card
          </label> */}
        </div>

        {paymentError && (
          <WidgetPaymentError
            message={"Something went wrong"}
          />
        )}
      </div>
    </div>

  )
}

export default WidgetNewCard
